import React from 'react';
import  { connect } from 'react-redux';
import { logginRequest, isLoggedIn } from '../../reducers/auth';
import { setAsResidentMemberOnBoarding, setAsVirtualMemberOnBoarding, VIRTUAL } from '../../reducers/currentProgressOnboardingWizard';
import { Route} from 'react-router-dom';


function tokenGuard({ onboardingType,
                      announceVirtualOnboarding,
                      announceResidentOnboarding,
                      ...props}){
  const isVirtualFlow = onboardingType === VIRTUAL;
  isVirtualFlow ? announceVirtualOnboarding() : announceResidentOnboarding();
    return <Route {...props}/>
}

const mapStateToProps = (state) => ({
  isLoginCompleted: isLoggedIn(state)
});

const mapDisptachToProps = (dispatch) => ({
  login: (token) => dispatch(logginRequest(token)),
  announceVirtualOnboarding: () => dispatch(setAsVirtualMemberOnBoarding()),
  announceResidentOnboarding: () => dispatch(setAsResidentMemberOnBoarding()),
});

export default connect(mapStateToProps, mapDisptachToProps)(tokenGuard);



// WEBPACK FOOTER //
// ./src/components/Auth/TokenGuard.js